var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMonitorEngineContext } from "@nibfe/mcp-monitor-sdk";
import { useRequest } from "./useRequest";
import { API_PATH } from "./useRequest";
import { getLBSInfo } from '@nibfe/mkt-lbs-api';
import { OperateType, DrawStatus } from "@/types/cityOrderTask";
import { useEffect, useState } from "@max/max";
import { DRAW_LIMIT_CODE } from '@/types/shared';
export function useCityOrderTask(options) {
    const ctx = useMonitorEngineContext();
    // const { inviter } = ctx._runtimeInfo?.queryParams || {};
    const [remainDrawTimes, setRemainDrawTimes] = useState(0); // 剩余抽奖次数
    const [remainLightTimes, setRemainLightTimes] = useState(0); // 剩余今日可许愿机会
    const [drawStatus, setDrawStatus] = useState(DrawStatus.unDraw); // 抽奖状态
    const [orderInfo, setOrderInfo] = useState(null);
    const [cityInfoList, setCityInfoList] = useState([]); // 轮播城市信息
    const [lightCityInfo, setLightCityInfo] = useState([]); // 点亮城市信息
    const [optionalCityList, setOptionalCityList] = useState([]); // 可选点亮城市列表
    const [isCityModalVisible, setCityModalVisible] = useState(false); // 城市列表浮层
    const [isDrawResultModalVisible, setIsDrawResultModalVisible] = useState(false); // 添加抽奖结果成功弹窗状态
    const [isDrawResultFailModalVisible, setIsDrawResultFailModalVisible] = useState(false); // 添加抽奖结果失败弹窗状态
    const [isLightUpCityModalVisible, setLightUpCityModalVisible] = useState(false);
    const [hasHotelOrder, setHasHotelOrder] = useState(false);
    const [isFirstRequestFinish, setIsFirstRequestFinish] = useState(false);
    const [isNetWorkErrorRender, setIsNetWorkErrorRender] = useState(false);
    const [winningOrderInfo, setWinningOrderInfo] = useState(undefined);
    // 定位相关状态
    const [location, setLocation] = useState();
    const [locationDone, setLocationDone] = useState(false);
    const [cityOrderRequestCode, setCityOrderRequestCode] = useState(0);
    const { requestStatus, request } = useRequest(API_PATH.CITY_ORDER_TASK, {
        showLoading: true
    });
    // 获取定位信息
    useEffect(() => {
        function fetchLocation(ctx) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const commonParams = ((_a = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _a === void 0 ? void 0 : _a.commonParams) || {};
                    const { cityInfo } = commonParams;
                    const { cityId, locCityId } = cityInfo;
                    const locationData = yield getLBSInfo({
                        sceneToken: 'mcp_tex_team_ranking_free',
                        needLocation: true
                    });
                    setLocation({
                        lat: String((_b = locationData === null || locationData === void 0 ? void 0 : locationData.gpsLocation) === null || _b === void 0 ? void 0 : _b.lat),
                        lng: String((_c = locationData === null || locationData === void 0 ? void 0 : locationData.gpsLocation) === null || _c === void 0 ? void 0 : _c.lng),
                        locateCityId: Number(locCityId) || Number(cityId) || locationData.homeSelectedCity // 定位城市||选择城市||app首页城市
                    });
                }
                catch (err) {
                    console.log('Failed to get location', err);
                }
                finally {
                    setLocationDone(true);
                }
            });
        }
        fetchLocation(ctx);
    }, [ctx]);
    function getCityOrderTask(extParams) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            const { isNetWorkErrorRender: isShowNetWork = false, operateType = OperateType.queryDraw, cityId } = extParams || {};
            setCityOrderRequestCode(0);
            try {
                const res = yield request(Object.assign(Object.assign({ operate: operateType, cityId, userLatitude: location === null || location === void 0 ? void 0 : location.lat, userLongitude: location === null || location === void 0 ? void 0 : location.lng, locateCityId: location === null || location === void 0 ? void 0 : location.locateCityId }, options), { playType: 27 }));
                setIsNetWorkErrorRender(isShowNetWork);
                if (!res) {
                    throw new Error('获取城市抽免单失败');
                }
                if (res.uni_status_code) {
                    setCityOrderRequestCode(res.uni_status_code);
                    return {
                        isSuccess: false,
                        data: null,
                        code: res.uni_status_code
                    };
                }
                setRemainDrawTimes(res.remainDrawTimes);
                setRemainLightTimes(res.remainLightTimes);
                setDrawStatus(res.drawStatus);
                setCityInfoList(res.cityInfoList || []);
                setOptionalCityList(res.optionalCityList || []);
                setHasHotelOrder(res.hasHotelOrder);
                (_b = (_a = ctx._raptorReport).monitorReportBizSuccess) === null || _b === void 0 ? void 0 : _b.call(_a);
                const lightCityInfo = res.lightCityInfo || [];
                lightCityInfo.forEach(item => item.isWishCity = true);
                setLightCityInfo(lightCityInfo);
                setWinningOrderInfo(res.winningOrderInfo);
                return {
                    isSuccess: true,
                    data: res
                };
            }
            catch (error) {
                ctx._uiInteractionAPI.toast.show({
                    content: '网络开小差了，请重试'
                });
                (_d = (_c = ctx._raptorReport).monitorReportBizFailed) === null || _d === void 0 ? void 0 : _d.call(_c);
                ctx._raptorReport.monitorReportLog(error.message, error, {
                    category: 'ajaxError',
                    level: 'error'
                });
                return {
                    isSuccess: false,
                    data: null
                };
            }
        });
    }
    // 点击许愿城市，需要判断是否有机会修改许愿城市
    function handleToChangeCity() {
        return __awaiter(this, void 0, void 0, function* () {
            const { isSuccess } = yield getCityOrderTask({
                operateType: OperateType.queryDraw
            });
            if (!isSuccess)
                return;
            // 使用最新获取的lightCityInfo和remainLightTimes进行判断
            if (remainLightTimes > 0) {
                // 有许愿次数，则展示城市选择弹窗
                setCityModalVisible(true);
                return true;
            }
            ctx._uiInteractionAPI.toast.show({
                content: '今日许愿次数已用完'
            });
            return false;
        });
    }
    function handleDraw() {
        return __awaiter(this, void 0, void 0, function* () {
            if (remainDrawTimes <= 0) {
                ctx._uiInteractionAPI.toast.show({
                    content: '抽奖次数已用完'
                });
                return;
            }
            const { isSuccess, data, code } = yield getCityOrderTask({
                operateType: OperateType.drawFree
            });
            if (!isSuccess) {
                if (code === DRAW_LIMIT_CODE) {
                    ctx._uiInteractionAPI.toast.show({
                        content: 'oops！今天已经抽太多啦，明日再来抽吧！'
                    });
                }
                return;
            }
            ;
            if (data && data.drawStatus === DrawStatus.drawSuccess) {
                setOrderInfo(data.orderInfo);
                setIsDrawResultModalVisible(true);
                yield getCityOrderTask({
                    operateType: OperateType.queryDraw
                });
            }
            else if ((data === null || data === void 0 ? void 0 : data.drawStatus) === DrawStatus.drawFail) {
                setIsDrawResultFailModalVisible(true);
                setOrderInfo(null);
            }
            else {
                ctx._uiInteractionAPI.toast.show({
                    content: '网络开小差了，请重试~'
                });
            }
        });
    }
    // 锁定预点亮城市
    function lockWishLightUpCity(cityId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (cityId === undefined)
                return {
                    isSuccess: false,
                    data: null
                };
            const res = yield getCityOrderTask({
                operateType: OperateType.lightUpCity,
                cityId
            });
            return res;
        });
    }
    useEffect(() => {
        const fetchData = () => __awaiter(this, void 0, void 0, function* () {
            // 等待定位完成后再请求数据
            if (locationDone) {
                const { isSuccess } = yield getCityOrderTask({
                    isNetWorkErrorRender: true
                });
                isSuccess && setIsFirstRequestFinish(true);
            }
        });
        fetchData();
    }, [locationDone]);
    return {
        cityOrderRequestCode,
        getCityOrderTask,
        requestStatus,
        remainDrawTimes,
        remainLightTimes,
        drawStatus,
        orderInfo,
        cityInfoList,
        lightCityInfo,
        optionalCityList,
        handleToChangeCity,
        isCityModalVisible,
        setCityModalVisible,
        handleDraw,
        isDrawResultModalVisible,
        setIsDrawResultModalVisible,
        setLightUpCityModalVisible,
        isLightUpCityModalVisible,
        lockWishLightUpCity,
        hasHotelOrder,
        setIsDrawResultFailModalVisible,
        isDrawResultFailModalVisible,
        isFirstRequestFinish,
        setIsFirstRequestFinish,
        isNetWorkErrorRender,
        location,
        locationDone,
        winningOrderInfo
    };
}
